"use client";

import React from "react";
import styles from "../css/successPopup.module.css";
import { usePopup } from "../context/PopupContext";

const SuccessPopup = ({ onClose, overlay = true }) => {
  const { openPopup, popupData } = usePopup();

  const handleViewProfile = () => {
    openPopup("mainMemberProfile", { mergedProfile: popupData?.mergedProfile });
  };

  const content = (
    <div className={styles.popup}>
      <button className={styles.closeButton} onClick={onClose}>
        ×
      </button>
      <div className={styles.checkmark}>✔</div>
      <h2 className={styles.title}>Profiles Merged Successfully</h2>
      <button className={styles.viewButton} onClick={handleViewProfile}>
        View Updated Profile
      </button>
    </div>
  );

  if (overlay) {
    return <div className={styles.overlay}>{content}</div>;
  }
  return content;
};

export default SuccessPopup;